// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"443":"bfac7f2c","464":"bfac7f2c","676":"e9c8be90","949":"fafc018e","966":"63942ed9"}[chunkId] + ".css";
};